import { Component, effect, inject } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { ProviderOrder } from 'src/app/calvin-emr-shared/models/provider-order.model';
import { AdministerMedDialogComponent } from '../administer-med-dialog/administer-med-dialog.component';

@Component({
  selector: 'app-prn-schedule',
  templateUrl: './prn-schedule.component.html',
  styleUrls: ['./prn-schedule.component.scss'],
  providers: [DialogService],
  standalone: true,
  imports: [
    TableModule,
    PrimeTemplate,
    ButtonDirective,
    TooltipModule,
  ],
})
export class PrnScheduleComponent {
  private patientStore = inject(PatientDashboardStore);
  private dialogService = inject(DialogService);

  patient: Patient = new Patient();
  orders: ProviderOrder[] = [];

  constructor() {
    effect(() => {
      this.patient = this.patientStore.patient();
      this.orders = this.patient.providerOrders.filter((order) => order.isPRN);
    });
  }

  openAdministerMedDialog(order: ProviderOrder): void {
    const dialogRef = this.dialogService.open(AdministerMedDialogComponent, {
      header: `Administering medication for: ${this.patient.getNameFirstMiddleLast()}`,
      data: { patient: this.patient, order },
      width: '50%',
      closable: false,
    });

    // This data comes back from onCloseClick in administer-med-dialog.component.html
    dialogRef?.onClose.subscribe((res: {
      order: ProviderOrder;
      administered: boolean;
    }) => {
      if (res.order && res.administered) {
        // If the order was a PRN order, then update the order's prnLastGivenTime.
        const date = new Date();
        res.order.prnLastGivenTime = {
          hour: date.getHours(),
          minute: date.getMinutes()
        };

        // Update the store with any changes to the objects (quantityGiven, etc.)
        const indexToSplice = this.patient.providerOrders.findIndex((o) => o.id == order.id);
        this.patient.providerOrders.splice(indexToSplice, 1, order);
        this.patientStore.setField({
          field: 'providerOrders',
          data: this.patient.providerOrders,
        });
      }
    });
  }

}
